import { Report, toJsonlLine } from './report-utils';

const report = new Report();

report.cleanupOldDateFolders();

export function appendReport(name: string, key: string, payload: any) {
  report.append(
    toJsonlLine({ time: new Date().toISOString(), key: `[${name}] ${key}`, payload })
  );
}

export function exportReport() {
  return report.export().catch(() => []);
}
